import axios from "axios";
import {
  addNewsFailure,
  addNewsStart,
  addNewsSuccess,
  deleteNewsFailure,
  deleteNewsStart,
  deleteNewsSuccess,
  fetchNewsFailure,
  fetchNewsStart,
  fetchNewsSuccess,
} from "../slicer/GalleryAndNewsSlice";


const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
export const addNews = (formData, onSuccess) => async (dispatch) => {
  dispatch(addNewsStart());
  try {
    // Log formData for debugging
    console.log("FormData being sent:", Object.fromEntries(formData.entries()));

    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data", // Ensure multipart form-data
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`; // Add Authorization if token exists
    }

    // Make the API request
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/addNews`,
      formData,
      { headers } // Passed the combined headers object
    );

    // Dispatch success action
    dispatch(addNewsSuccess(response.data.data));
    console.log("News added successfully:", response.data);

    // Trigger success callback if provided
    if (onSuccess) onSuccess();
  } catch (error) {
    // Log error for debugging
    console.error(
      "Error adding news:",
      error.response?.data || error.message
    );

    // Dispatch failure action
    dispatch(
      addNewsFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );

    // Show an alert for the error
    alert(
      `Error adding news: ${
        error.response?.data?.message || error.message || "Internal server error"
      }`
    );
  }
};

export const fetchNewsData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchNewsStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getNews`,
      getAuthHeaders() // Added authentication headers
    );

    if (response.data.success) {
      dispatch(fetchNewsSuccess(response.data.data)); // Dispatch only the "data" array
    } else {
      dispatch(fetchNewsFailure("Failed to fetch news data"));
    }
  } catch (error) {
    console.error("Error fetching News data:", error);
    dispatch(
      fetchNewsFailure(
        error.response?.data?.message || "Failed to fetch News data"
      )
    );
  }
};

export const deleteNews = (Id) => async (dispatch) => {
  dispatch(deleteNewsStart());
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/deleteNews/${Id}`,
      getAuthHeaders() // Added authentication headers
    );

    if (response.data.success) {
      dispatch(deleteNewsSuccess(Id)); // Update state to remove the deleted item
      dispatch(fetchNewsData()); // Refetch the news list to ensure the UI is updated
    } else {
      dispatch(deleteNewsFailure("Failed to delete news"));
    }
  } catch (error) {
    console.error("Error deleting news:", error);
    dispatch(
      deleteNewsFailure(
        error.response?.data?.message || "Failed to delete news"
      )
    );
  }
};

export const updateNewsData = (id, payload) => async (dispatch) => {
  try {
    // Dispatch the start action to indicate the update process has started
    dispatch({ type: "updateNewsStart" });

    const token = getToken(); // Get token
    const headers = {}; // Initialize headers object
    // If payload is FormData, you might not explicitly set Content-Type here,
    // as axios typically handles it for FormData. However, always include Auth.
    // If 'payload' is not FormData and is JSON, you might want to set 'Content-Type': 'application/json'
    if (token) {
      headers["Authorization"] = `Bearer ${token}`; // Add Authorization if token exists
    }

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/updateNews/${id}`,
      payload, // FormData is passed here
      { headers } // Passed the combined headers object
    );

    // Dispatch the success action with the updated data
    dispatch({
      type: "updateNewsSuccess",
      payload: response.data,
    });

    // Optionally show a success alert
    alert("News updated successfully!");

    // Return the updated data
    return response.data;
  } catch (error) {
    console.error("Error updating news:", error);

    // Dispatch the failure action with an error message
    dispatch({
      type: "updateNewsFailure",
      payload: error.response?.data?.message || "Something went wrong.",
    });

    // Show an error alert
    alert(`Error updating news: ${error.message || "Something went wrong."}`);

    // Re-throw the error for further handling
    throw error;
  }
};